import {
  images,
  scrolling,
} from 'assets/utilities';

import './blog.scss';

const state = {};

const setActiveNav = function setActiveBlogNav() {
  const { pathname } = window.location;

  [].forEach.call(
    document.querySelectorAll('.js-blogSelect option'),
    (el) => {
      el.selected = el.getAttribute('value') === pathname; // eslint-disable-line no-param-reassign
    },
  );
};

const onChange = function onBlogChange(ev) {
  const target = ev.currentTarget.value;
  state.changeState(target);
};

const destroy = function destroyBlog() {
  [].forEach.call(
    document.querySelectorAll('.js-blogSelect'),
    el => el.removeEventListener('change', onChange),
  );
};

const init = function initBlog(routerProps) {
  window.scrollTo(0, 0);
  scrolling.rebuildCache();
  images.init();
  setActiveNav();

  state.changeState = routerProps.changeState;

  [].forEach.call(
    document.querySelectorAll('.js-blogSelect'),
    el => el.addEventListener('change', onChange),
  );
};

export default {
  destroy,
  init,
};
